'use strict';

import React from 'react';
import PropTypes from 'prop-types';

export default class SelectYearFrom extends React.Component {
  static propTypes = {
    startYear: PropTypes.number.isRequired,
    endYear: PropTypes.number.isRequired,
    defaultValue: PropTypes.string.isRequired,
    updater: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { value: props.defaultValue };
  }

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ value: value });
    this.props.updater.emit('year_from_selected', value);
  }

  optionsToSelect() {
    var options = [<option value="" key={0} />];
    for (var i = this.props.startYear; i < this.props.endYear; i++) {
      options.push(<option value={i} key={i}>{i}</option>);
    }
    return options;
  }

  render() {
    return (
      <select
        ref="select"
        value={this.state.value}
        className="form-control"
        name="race_category[year_born_from]"
        onChange={this.handleChange}>
        {this.optionsToSelect()}
      </select>
    );
  }
}
